import { createSlice } from '@reduxjs/toolkit'
import name from './name'

/**
 * Stores quiz interaction state keyed by quizId.
 *
 * Each entry shape:
 *
 * Matrix quiz:
 *   { type: 'matrix', questions: [{ id, choices: [{ id, checked }] }], score: number | null }
 *
 * MCQ quiz:
 *   { type: 'mcq', questions: [{ id, choices: [{ id, selected }], locked }],
 *     quizSubmitted: bool, attemptsUsed: number, answersRevealed: bool }
 *
 * This slice is intentionally NOT reset on content navigation so results can
 * be surfaced in content cards and other cross-page surfaces in the future.
 */
export const quizResults = createSlice({
  name,
  initialState: {},
  reducers: {
    saveQuizState: (state, { payload: { quizId, quizState } }) => {
      state[quizId] = quizState
    },
    reset: () => ({})
  }
})

export const { saveQuizState, reset } = quizResults.actions
export default quizResults.reducer
